import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IIssueType } from "@common/interfaces/issueType";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface IssueTypeState extends EntityState<IIssueType, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUE_TYPES , realtimeEntity: 'IssueType'})
export class IssueTypeStore extends EntityStore<IssueTypeState> {
  constructor() {
    super([]);
  }
}
